/**
 * Replaces path separators in a filename with underscores so that the zip
 * library treats it as a single entry instead of a folder hierarchy.
 */
export function sanitizeZipFilename(filename: string): string {
  return filename.replace(/[/\\]/g, '_')
}
